<template>
  <div id="listings-row" class="row listings-row">
    <div class="col-12">
      <div class="row listings-info-row">
        <div class="col-12">
          <div class="container">
          <div class=" d-flex justify-content-between align-items-center sort-container">
            <Pagination v-model="page" :records="numberOfListings" :per-page="perPage" :options="paginationOptionsTop" />

            <div class="form-group mb-0">
              <select v-model="sortBy" @change="resetPagination" class="form-control form-control-sm">
                <option v-for="option in sortOptions" :value="option.value" :key="option.value">
                  {{ option.text }}
                </option>
              </select>
            </div>
          </div>
          </div>


        </div>
      </div>

      <!-- Spinner Start -->
      <div id="spinner" class="row" v-if="spinner">
        <div class="col-12">
          <div id="preloader">
              <span></span>
              <span></span>
              <span></span>
              <span></span>
              <span></span>
          </div>
        </div>
      </div>

      <!-- Spinner End -->
      <div class="container">
      
        <div class="row noListingsRow" v-if="numberOfListings == 0 && !spinner">
          <div class="col-12">
            <p>No listings matching this search</p>
          </div>
        </div>
        
        <div class="row">
          <article v-for="listing in paginatedListings" :key="listing.DocumentID" class="col-12 col-md-6 col-lg-4 listing-container">
            <a :href="listing.link">
              <div class="listing-item">
                <div class="listings-picture-container">
                  <!-- <img class="listings-picture" :src="'https://latitudeyachtimages.azurewebsites.net/api/getimageresized?imageUri=' + listing.meta.ketch_boat_images[0].Uri + '&dateModifiedString=' + listing.meta.ketch_boat_images[0].LastModifiedDateTime + '&width=510'" alt=""> -->
                  <img
                    :src="'https://latitudeyachtimages.azurewebsites.net/api/getimageresized?imageUri=' + listing.meta.ketch_boat_images[0].Uri + '&dateModifiedString=' + listing.meta.ketch_boat_images[0].LastModifiedDateTime + '&width=510'" 
                    :srcset="'https://latitudeyachtimages.azurewebsites.net/api/getimageresized?imageUri=' + listing.meta.ketch_boat_images[0].Uri + '&dateModifiedString=' + listing.meta.ketch_boat_images[0].LastModifiedDateTime + '&width=510' + ' 510w, ' + 'https://latitudeyachtimages.azurewebsites.net/api/getimageresized?imageUri=' + listing.meta.ketch_boat_images[0].Uri + '&dateModifiedString=' + listing.meta.ketch_boat_images[0].LastModifiedDateTime + '&width=350' + ' 350w, '" 
                    sizes="(min-width: 768px) 350px, 510px" 
                    class="listings-picture" 
                    :alt="listing.meta.ketch_boat_make[0] + ' ' + listing.meta.ketch_boat_model[0]" 
                    loading="lazy"
                  >
                </div>
                <div class="listings-desc-container">
                  <div class="model-year-location">
                    <span>{{listing.meta.ketch_boat_model_year[0]}}</span>
                    <span><span class="loc-icon"><b-icon icon="geo-alt-fill"></b-icon></span> {{listing.meta.ketch_boat_location_city[0]}}, {{listing.meta.ketch_boat_location_country[0]}}</span>
                  </div>
                  <h3>{{listing.meta.ketch_boat_make[0]}}</h3>
                  <h4>{{listing.meta.ketch_boat_model[0]}} </h4>
                  
                  <div class="model-size">{{(listing.meta.ketch_boat_length[0] * 3.281).toFixed(2)}} ft. ({{listing.meta.ketch_boat_length[0]}}m)</div>
                  <p class="price">${{Number(listing.meta.ketch_boat_price[0]).toLocaleString()}}</p>
                </div>
              </div>
            </a>
          </article>
        </div>
        
        <div class="row mt-4 mb-5">
          <div class="col-12 pagination-col text-center">
              <Pagination v-model="page" :records="numberOfListings" :per-page="perPage" :options="paginationOptions" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Pagination from 'vue-pagination-2';
import TopPagination from './TopPagination.vue';
import BottomPagination from './BottomPagination.vue';

export default {
  name: 'ListingsContainer',
  props: {
    listings: Array,
    spinner: Boolean
  },
  data() {
    return {
      page: 1,
      perPage: 12,
      paginationOptionsTop: {
        chunk: 5,
        chunksNavigation: 'fixed',
        edgeNavigation: true,
        texts: { 
          count: 'Showing <strong>{from}</strong> to <strong>{to}</strong> of <strong>{count}</strong> results|<strong>{count}</strong> results|<strong>1</strong> result'
        },
        template: TopPagination
      },
      paginationOptions: {
        chunk: 5,
        chunksNavigation: 'fixed',
        edgeNavigation: true,
        template: BottomPagination
      },
      numOfListings: this.listings.length,
      sortBy: 'longest',
      sortOptions: [
      { text: 'Lowest Price', value: 'lowest' },
      { text: 'Highest Price', value: 'highest' },
      { text: 'Longest Length', value: 'longest' },
      { text: 'Shortest Length', value: 'shortest' }
    ]
    }
  },
  components: {
    Pagination,
  },
  methods: {
    resetPagination() {
      this.page = 1;
    }
  },
  computed: {
    numberOfListings(){
      return this.listings.length
    },
    sortedListings(){
      const listings = this.listings.map( i => ({ ...i }));

      if (this.sortBy === 'lowest' ) {
        sessionStorage.setItem('ketch_sort', 'lowest'); 
        return listings.sort((a,b) => {
          return parseFloat(a.meta.ketch_boat_price[0]) - parseFloat(b.meta.ketch_boat_price[0])
        })
      }

      if (this.sortBy === 'highest' ) {
        sessionStorage.setItem('ketch_sort', 'highest'); 
        return listings.sort((a,b) => {
          return parseFloat(b.meta.ketch_boat_price[0]) - parseFloat(a.meta.ketch_boat_price[0])
        })
      }

      if (this.sortBy === 'shortest' ) { 
        sessionStorage.setItem('ketch_sort', 'shortest');
        return listings.sort((a,b) => {
          return parseFloat(a.meta.ketch_boat_length[0]) - parseFloat(b.meta.ketch_boat_length[0])
        })
      }

      if (this.sortBy === 'longest' ) {
        sessionStorage.setItem('ketch_sort', 'longest'); 
        return listings.sort((a,b) => {
          return parseFloat(b.meta.ketch_boat_length[0]) - parseFloat(a.meta.ketch_boat_length[0])
        })
      }

      else {
        return listings
      }
      
    },
    paginatedListings() {
      let startIndex = this.perPage * (this.page - 1);
      const endIndex = startIndex + this.perPage;
      
      if (startIndex >= this.sortedListings.length ) {
        startIndex = 0;
      }

      return this.sortedListings.slice(startIndex, endIndex);
    }
  },
  watch: {
    listings: function() {
      this.page = 1;
    }
  },
  created(){
  if (sessionStorage.getItem("ketch_sort") === null) {
    this.sortBy = 'longest';
  } else {
    const ketchSort = sessionStorage.getItem('ketch_sort');
    this.sortBy = ketchSort;
  }
}
}
</script>

<style lang="scss" scoped>

@import '../assets/global.scss';

  

  #listings-row {
    //background-color: #f9fafb;
    // bootstrap styles
    .form-control {
        display: block;
        width: 100%;
        height: calc(1.5em + 0.75rem + 2px);
        padding: 0.375rem 0.75rem;
        font-size: 1rem;
        font-weight: 400;
        line-height: 1.5;
        color: #495057;
        background-color: #fff;
        background-clip: padding-box;
        border: 1px solid #ced4da;
        border-radius: 0.25rem;
        transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    }

    .form-control-sm {
        height: calc(1.5em + 0.5rem + 2px);
        padding: 0.25rem 0.5rem;
        font-size: 0.875rem;
        line-height: 1.5;
        border-radius: 0.2rem;
    }

    input {
      overflow: visible;
      margin: 0;
    }
    //bootstrap styles

    .noListingsRow {
      font-weight: 700;
      color: #dc3545;
    }

    .form-control {
      border-radius: 0;
      border-color: $ltgray;
      margin-bottom: 0;
    }
    
    .form-control-sm {
      min-width: 130px;
    }

    .sort-container {
      background-color: #e7e7e7;
      padding: 15px 0px;
    }

    .listings-info-row {
      background-color: #e7e7e7;
      margin-bottom: 30px;
    }

    .listing-container {
      box-sizing: border-box;

      a {
        text-decoration: none;
        color: #495057;

        &:hover {
          color: #495057;
        }
      }

      .listing-item {
        border-radius: 0;
        box-shadow: 0 2px 0 0 #ecf0f0, 0 3px 7px 0 transparent;
        background: #fff;
        cursor: pointer;
        transition: box-shadow .15s linear;
        margin-bottom: 30px;

        &:hover {
          box-shadow: 0 2px 0 0 #d7d7d7, 0 3px 7px 0 rgba(0,0,0,.15);
        }

        .listings-picture-container {
          max-width: 100%;
          aspect-ratio: 16 / 9;
          background-color: #fff;
          background-size: cover;
          background-repeat: no-repeat;
          background-position: center center;
          overflow: hidden;
          position: relative;

          .listings-picture {
            position: absolute;
            top: -9999px;
            bottom: -9999px;
            left: -9999px;
            right: -9999px;
            margin: auto;
            max-width: 100%;
          }

        }

        .listings-desc-container {
          text-align: left;
          padding: 12px;

          .model-year-location {
            font-size: 14px;
            font-weight: 300;
            width: 100%;
            display: flex;
            justify-content: space-between;
            margin-bottom: .75rem;

            .loc-icon {
              color: $gold;
              margin-right: .2rem;
            }
          }

          h3 {
            font-family: $fjalla;
            font-size: 22px;
            font-weight: 500 !important;
            color: $blue;
            text-transform: uppercase;
            margin-bottom: 0.25rem;
          }

          h4 {
            font-family: $lato !important;
            font-size: 16px;
            font-weight: 500;
            color: $blue;
            margin-bottom: .75rem;
            text-transform: inherit !important;
          }

          .model-size {
            font-size: 14px;
            font-weight: 300;
          }

          .price {
            font-size: 18px;
            font-weight: 700;
            margin-top: .5rem;
            margin-bottom: 0;
          }
        }
      }
    }
    

  }

  //preloader
#spinner {
  height: calc(100vh - 98px);
  align-items: flex-start;
  padding-top: 100px;
}

  #preloader {
  display: block;
  position: absolute;
  top: 50%;
  left: 50%;
  height: 50px;
  width: 50px;
  margin: -25px 0 0 -25px;
}

#preloader span {
  position: absolute;
  display: block;
  bottom: 10px;
  width: 9px;
  height: 5px;
  background: rgba(28, 45, 61, .25);
  -webkit-animation: preloader 1.5s  infinite ease-in-out;
          animation: preloader 1.5s  infinite ease-in-out;
}

#preloader span:nth-child(2) {
  left: 11px;
  -webkit-animation-delay: 0.2s;
          animation-delay: 0.2s;
}

#preloader span:nth-child(3) {
  left: 22px;
  -webkit-animation-delay: 0.4s;
          animation-delay: 0.4s;
}

#preloader span:nth-child(4) {
  left: 33px;
  -webkit-animation-delay: 0.6s;
          animation-delay: 0.6s;
}

#preloader span:nth-child(5) {
  left: 44px;
  -webkit-animation-delay: 0.8s;
          animation-delay: 0.8s;
}

@keyframes preloader {
  0% {
    height: 5px;
    -webkit-transform: translateY(0px);
            transform: translateY(0px);
    -webkit-transform: translateY(0px);
            transform: translateY(0px);
    background: rgba(28, 45, 61, .25);
  }
  25% {
    height: 30px;
    -webkit-transform: translateY(15px);
            transform: translateY(15px);
    -webkit-transform: translateY(15px);
            transform: translateY(15px);
    background: $blue;
  }
  50% {
    height: 5px;
    -webkit-transform: translateY(0px);
            transform: translateY(0px);
    -webkit-transform: translateY(0px);
            transform: translateY(0px);
    background: rgba(28, 45, 61, .25);
  }
  100% {
    height: 5px;
    -webkit-transform: translateY(0px);
            transform: translateY(0px);
    -webkit-transform: translateY(0px);
            transform: translateY(0px);
    background: rgba(28, 45, 61, .25);
  }
}
@-webkit-keyframes preloader {
  0% {
    height: 5px;
    -webkit-transform: translateY(0px);
            transform: translateY(0px);
    background: rgba(28, 45, 61, .25);
  }
  25% {
    height: 30px;
    -webkit-transform: translateY(15px);
            transform: translateY(15px);
    background: $blue;
  }
  50% {
    height: 5px;
    -webkit-transform: translateY(0px);
            transform: translateY(0px);
    background: rgba(28, 45, 61, .25);
  }
  100% {
    height: 5px;
    -webkit-transform: translateY(0px);
            transform: translateY(0px);
    background: rgba(28, 45, 61, .25);
  }
}

  

  
</style>
